import { useEffect } from "react";
import { tenantSlugFromHost } from "@/lib/tenant";

// Hard-cut de subdomínios legados: se o usuário acessar fazbem.usegestao.app.br,
// redireciona para usegestao.app.br/fazbem preservando o path e a query.
// Roda apenas 1x no mount do App. Silencioso em preview (host não casa).
export function SubdomainRedirect() {
  useEffect(() => {
    const slug = tenantSlugFromHost();
    if (!slug) return;
    const { pathname, search, hash } = window.location;
    // Se o path já começa com /{slug}, evita loop
    const target = `https://usegestao.app.br/${slug}${pathname === "/" ? "" : pathname}${search}${hash}`;
    window.location.replace(target);
  }, []);
  return null;
}
